import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  static values = { debounceMs: { type: Number, default: 200 } }

  connect() {
    this.submitTimer = null
  }

  search() {
    this.clearTimer()
    this.submitTimer = setTimeout(() => this.submit(), this.debounceMsValue)
  }

  sort() {
    this.submit()
  }

  disconnect() {
    this.clearTimer()
  }

  submit() {
    this.clearTimer()
    this.formTarget.requestSubmit()
  }

  clearTimer() {
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
      this.submitTimer = null
    }
  }
}
